module.exports = __webpack_public_path__ + "img/big-pic4.36bbe8c5.png";